module.exports = __webpack_public_path__ + "img/about-03.ef65dbe9.png";